var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAlatyr = function SvgAlatyr(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 509.000000 506.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,506.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3023 4328 l-443 -443 0 -633 c0 -347 3 -632 8 -632 4 0 204 197 445 438 l437 437 -2 638 -3 637 -442 -442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627 4753 c-4 -3 -7 -288 -7 -632 l0 -626 403 -400 c221 -220 421 -418 445 -440 l42 -39 0 636 0 635 -431 437 c-237 240 -434 436 -438 436 -4 0 -11 -3 -14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 3453 c-25 -3 -49 -9 -55 -14 -7 -7 134 -153 430 -445 l440 -434 632 0 c348 0 633 3 633 8 0 4 -199 206 -443 450 l-442 442 -575 -2 c-316 -1 -595 -3 -620 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3072 3017 c-243 -243 -442 -445 -442 -450 0 -4 285 -7 633 -7 l632 0 450 450 450 450 -640 0 -640 0 -443 -443z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273 2491 l-92 -6 -440 -430 -440 -430 647 -3 647 -3 418 423 c230 233 423 431 428 441 9 16 -19 17 -533 15 -299 -1 -584 -4 -635 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 2491 c0 -4 192 -202 426 -440 l426 -431 645 0 c354 0 643 4 641 8 -1 4 -198 199 -436 432 l-434 425 -101 6 c-158 10 -1167 10 -1167 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2058 2007 l-438 -433 0 -644 1 -645 444 450 444 450 1 628 c0 345 -3 627 -7 626 -5 0 -205 -195 -445 -432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580 1813 l0 -630 434 -439 c238 -241 438 -435 442 -431 5 5 10 288 12 630 l3 621 -318 318 c-175 176 -375 374 -445 440 l-128 120 0 -629z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlatyr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alatyr.54d045c4.svg";
export { ForwardRef as ReactComponent };